import * as apiBookmark from '@/api/bookmark'
import * as apiTags from '@/api/tag'
import * as _ from 'lodash'
import store from '@/store'
import { isFromAdminSystem } from '@/util/common'

const getDefaultState = () => {
  const defaults = {
    lists: [],
    tags: [],
    complete: false,
    canload: true,
    start: 0,
    per_page: 30,
    count: null,
    currentId: null,
    filterTags: []
  }

  return defaults
}

const bookmark = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getCurrentList: (state) => _.find(state.lists, list => list.bookmark_id === state.currentId)
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    setLists: (state, lists) => {
      state.lists.push(...lists)
    },
    setStart: (state, num) => {
      state.start = num
    },
    subtractionStart: (state) => {
      state.start--
    },
    setCount: (state, num) => {
      state.count = num
    },
    subtractionCount: (state) => {
      state.count--
    },
    setComplete: (state) => {
      state.complete = true
    },
    setCanload: (state, boolean) => {
      state.canload = boolean
    },
    setTagLists: (state, lists) => {
      state.tags.splice(0, state.tags.length)
      state.tags.push(...lists)
    },
    resetLists: (state) => {
      state.lists.splice(0, state.lists.length)
    },
    resetComplete: (state) => {
      state.complete = false
    },
    resetAll: (state) => {
      Object.assign(state, getDefaultState())
    },
    setId: (state, id) => {
      state.currentId = id
    },
    updateList: (state, { index, id, title, tags }) => {
      const prev = state.lists[index]
      prev.title = title
      prev.tags = tags
      state.lists.splice(index, 1, prev)
    },
    deleteList: (state, index) => {
      state.lists.splice(index, 1)
    },
    setFilterTags: (state, tags) => {
      state.filterTags = tags
    }
  },
  actions: {
    getCount: ({ commit, state }) => {
      const params = {
        type: 1, // 1(ブックマーク)
        tags: state.filterTags,
        key: '' // qa(QA)、knowledge(ナレッジ)、両方取得なので空
      }
      apiBookmark
        .count(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            commit('setCount', data.count)
          }
        })
    },
    setFilterTags: async ({ commit }, tags) => {
      await commit('setFilterTags', tags)
    },
    getLists: async ({ commit, state, dispatch }) => {
      const params = {
        start: state.start,
        per_page: state.per_page,
        search_order: 'created', // created(作成日順)
        ascending: 'desc',
        type: 1, // 1(ブックマーク)
        tags: state.filterTags,
        key: '' // qa(QA)、knowledge(ナレッジ)、両方取得なので空
      }
      if (state.canload) {
        commit('setCanload', false)
        const res = await apiBookmark
          .list(params)
          .then(async(response) => {
            const { data } = response
            if (data.status === 0) {
              const { lists } = data
              if (lists && lists.length > 0) {
                const start = state.start + lists.length
                await commit('setStart', start)
                await commit('setLists', lists)
                commit('setCanload', true)
              } else {
                commit('setCanload', true)
                commit('setComplete')
              }
              dispatch('getCount')
            } else {
              if (!isFromAdminSystem()) {
                // status=その他: エラーダイアログを表示
                store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
              }
            }
            return data
          })
        return res
      }
    },
    resetLists: ({ commit, state, dispatch }) => {
      // 前回から絞り込みの条件が変わっていた場合は一覧をリセットする
      const interval = setInterval(() => {
        if (state.canload) {
          commit('resetLists')
          commit('resetComplete')
          commit('setStart', 0)
          commit('setCount', null)
          dispatch('getLists')
          clearInterval(interval)
        }
      }, 100)
    },
    getTags: async ({commit}) => {
      const params = {
        start: 0,
        per_page: 30,
        search_order: 'created', // created(日付順)
        ascending: 'desc',
        type: 'bookmark' // bookmark(ブックマーク)
      }
      await apiTags
        .list(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const { lists } = data
            commit('setTagLists', lists)
          }
        })
    },
    setEditId: async ({ commit }, id) => {
      await commit('setId', id) 
    },
    update: async ({ commit, state }, params) => {
      const res = await apiBookmark
        .update(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const save = _.clone(params)
            const index = _.findIndex(state.lists, list => list.bookmark_id === params.id)
            save.index = index
            save.tags = _.map(params.tags, tag => {
              return { id: null, name: tag, num: null }
            })
            commit('updateList', save)
          }

          return response
        })
      
      return res
    },
    delete: async ({ commit, state }, params) => {
      await apiBookmark
        .remove(params)
        .then(response => {
          const { data } = response
          if (data.status === 0) {
            const index = _.findIndex(state.lists, list => list.bookmark_id === params.id)
            commit('deleteList', index)
            commit('subtractionCount')
            commit('subtractionStart')
          }
        })
    }
  }
}

export default bookmark
